import Shop from '../shop';

export default class Airline extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Airline',
            id:                   'Airline',
            coolDown:             3000,
            faClass:              'fa-plane',
            individualCostFactor: 1.115,
            baseEarnings:         1074000000.0,
            baseCosts:            2149908480.0,
            grade:                9
        });
    }
}
